/**
 * What a themed gallery page calls the occasion.
 *
 * The hero used to carry a generic heading — "The Selection", "Event Gallery" —
 * with the event's own name demoted to the small eyebrow above it. That reads
 * as the software naming the page rather than the studio naming the day, so the
 * title is now the event itself and the generic label is gone.
 *
 * Shared by the selection and full-event pages; the person page keeps its own
 * title, which is about a person rather than the event.
 */

/** The event's own name — falls back to the couple, then to a neutral label. */
export const buildEventTitle = (event) => {
  if (!event) return 'Gallery';
  if (event.event_name) return event.event_name;
  if (event.groom_name && event.bridal_name) return `${event.groom_name} & ${event.bridal_name}`;
  return 'Gallery';
};

/**
 * The line under the title. Deliberately does NOT repeat whatever became the
 * title — an event with a name shows its date, a couple already named in the
 * title is not named again.
 */
export const buildEventSubtitle = (event) => {
  if (!event) return '';
  const parts = [];
  if (event.event_name && event.groom_name && event.bridal_name) {
    parts.push(`${event.groom_name} & ${event.bridal_name}`);
  }
  if (event.event_date) {
    parts.push(new Date(event.event_date).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric',
    }));
  }
  return parts.join(' · ');
};
